import React, { useEffect, useState } from 'react';
import ProzoDataGrid from '../../common/ProzoDataGrid';
import { Box, Typography, Chip, Button } from '@mui/material';
import { maskAddress, maskPhoneNumber, parseDateAndTime, shouldMaskData } from '../../helpers/UtilityHelper';
import Loader from '../../common/Loader';
import { useGetNDRDataQuery } from '../../redux/commonRTK';
import { buildFilterConditions } from '../../helpers/UtilityHelper';
import ConfirmDialog from '../../common/ConfirmDialog';
import { apiConstants, post, postGeneric } from '../../common/constants';
import { useSnackbar } from "notistack";
import BulkOrderAction from "./bulkOrderAction";
import NdrAction from "./action";
import { LoadingButton } from "@mui/lab";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import { downloadNdrList } from "./downloadNdr";
import { getMerchant, getToken } from '../../helpers/ReduxHelpers'
import { useSelector } from 'react-redux';
import jwt_decode from "jwt-decode"
import { primaryTextSx, secondaryTextSx, cellStackSx, awbTextSx, getStatusChipSx, getPaymentChipSx } from '../orders/list2/cellStyles';
import { FONT, SIZE } from '../../styles/foundation/typography';
import { secondaryBtnSx } from '../../styles/patterns';
import { SUCCESS, ERROR, SUBTLE } from '../../styles/foundation/colors';
import AwbLinkCell from '../../common/AwbLinkCell';
const NETRA_BAND_COLOR = { EXCELLENT: '#2e7d32', GOOD: '#0288d1', FAIR: '#ed6c02', POOR: '#d32f2f' };

const DELHIVERY_BLOCKED_NSL_CODES = ["EOD-74", "EOD-15", "EOD-104", "EOD-43", "EOD-86", "EOD-11", "EOD-69", "EOD-6"];

function isDelhiveryReattemptBlocked(row) {
    const parent = row?.courierDetail?.parent;
    if (!parent || parent.toLowerCase() !== 'delhivery') return null;
    const history = row?.order_history;
    if (!Array.isArray(history) || history.length === 0) return null;
    const last = history[history.length - 1];
    if (last.orderStatusEnum !== 'FAILED_DELIVERY') return null;
    const nslCode = last.additional?.nsl_code;
    if (!nslCode) return null;
    if (DELHIVERY_BLOCKED_NSL_CODES.includes(nslCode)) return null;
    return { nslCode, remark: last.remark || '', latitude: last.additional?.latitude, longitude: last.additional?.longitude };
}


const PendingNdrData = (props) => {

    const [page, setPage] = useState(0);
    const [sizePerPage, setSizePerPage] = useState(10);
    const [pendingNdrData, setPendingNDRData] = useState({});
    const [rtoConfirm, setRtoConfirm] = React.useState(false);
    const [id, setId] = useState('');
    const { enqueueSnackbar } = useSnackbar()
    const [currentNDRId, setCurrentNDRId] = useState({});
    const [currentNDRAction, setCurrentNDRAction] = useState();
    const [actionShow, setActionShow] = useState(false);
    const [isExecuting, setIsExecuting] = useState(false);
    const [bulkOrderShow, setBulkOrderShow] = useState(false);
    const [isLoadingBtn, setIsLoadingBtn] = useState(false);
    const [reload, setReload] = useState(0)
    const [callRecordingsMap, setCallRecordingsMap] = useState({});
    const [whatsappMap, setWhatsappMap] = useState({});
    const merchant = getMerchant();
    const merchantId = merchant.id ? merchant.id : ''
    const { report } = useSelector(state => state);
    const { piiAccessAllow } = jwt_decode(getToken());


    const exclude =
        "shipmentDetail.cartonItems,invoiceNumber,shipmentType,returnInfo,labelUrl,dispatchMode,giftwrapCharge,transactionCharge,shippingCharge,pickupDetails,isInsured,codType,riskType,appointmentDelivery,async,order_date,courierDetail.prozoId,courierDetail.key,createdDate,actualPickUpTime,lastStatusUpdateTime,epd,edd,merchantPricing,merchant,courier,orderManifest,invoiceUrl,courierPricingRTO,courierPricing,overriddenCourierAccountCode,actualCourierProviderName,isDiscrepancyRaised,discrepancyId,securityKey,sortCode,channelType,channelName,itemList,createdByUser,skipRule,modifiedByUser,rvp_reason,channel_name,customerDetail,cpErrorList,mongoLabelSignedUrlDetails,overriddenCourierRule,mongoInvoiceSignedUrlDetails,merchant,modifiedByUser,lastModifiedDate,manifestDetails,communicationStatus,eddRemark,timeoutRetryCounter,isAutoApprovedReturn,appointdeliveryRequired,autoApprovedReturn,isManualCreate,gst_info,failureCategory";
    const filterConditions = buildFilterConditions(props.filters);
    const andfilter = [
        { field: "orderStatus", operator: "in", value: ["FAILED_DELIVERY", "SHIPMENT_HELD"] },
        { field: "ndrData.ndrStatus", operator: "nin", value: ["INITIATED", "CLOSED"] },
        { field: "merchant.$id", operator: "eq", value: merchantId },
        ...filterConditions.andfilter
    ];
    const orfilter = [...filterConditions.orfilter];

    const [downloading, setDownloading] = useState(false);
    const handleDownload = async () => {
        setDownloading(true);
        try {
            const n = await downloadNdrList({ andfilter, orfilter, excludes: exclude, fileName: `NDR_Pending_${new Date().toISOString().slice(0, 10)}.xlsx` });
            if (!n) enqueueSnackbar("No records to download", { variant: "info" });
        } catch (e) {
            enqueueSnackbar("Download failed, please try again", { variant: "error" });
        } finally {
            setDownloading(false);
        }
    };

    const { data: pendingData, isLoading, refetch } = useGetNDRDataQuery({
        andfilter,
        orfilter,
        offset: page * sizePerPage,
        limit: sizePerPage,
        skipCount: true,
        excludes: exclude,
        sort: { field: "awbRegisteredDate", direction: "DESC" },
    })

    // useEffect(() => {
    //     refetch()
    // }, [reload, refetch])

    useEffect(() => {
        setPage(0)
    }, [sizePerPage, props.filters])

    useEffect(() => {
        if (reload !== 0) {
            refetch();
        }
    }, [reload, refetch]);


    const columns = [
        {
            field: 'orderdetails', headerAlign: "left", hideSortIcons: true, headerName: 'Order Details', flex: 1.2, minWidth: 180, renderCell: (params) => {
                const { row } = params;
                const paymentMode = row.payment_mode || '';
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>{row.reference}</Typography>
                        {row.shippingLabelId && row.reference !== row.shippingLabelId && (
                            <Typography sx={secondaryTextSx}>{row.shippingLabelId}</Typography>
                        )}
                        <Typography sx={secondaryTextSx}>
                            {(row.awbRegisteredDate) ? parseDateAndTime(row.awbRegisteredDate) : ""}
                        </Typography>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                            {row.invoice_value && <Typography sx={primaryTextSx}>Rs. {row.invoice_value}</Typography>}
                            {paymentMode && <Chip size="small" label={paymentMode} sx={getPaymentChipSx(paymentMode)} />}
                        </Box>
                    </Box>
                )
            },
        },
        {
            field: 'courierDetails', headerAlign: "left", hideSortIcons: true, headerName: 'Courier Details', flex: 1, minWidth: 160, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <AwbLinkCell awb={row.awb_number} sx={awbTextSx} />
                        <Typography sx={secondaryTextSx}>{row?.courierDetail?.parent || row?.courierDetail?.name}</Typography>
                    </Box>
                )
            },
        },
        {
            field: 'addressQuality', headerAlign: "left", hideSortIcons: true, headerName: 'Address Quality', flex: 0.6, minWidth: 100, renderCell: (params) => {
                const { row } = params;
                if (!row.netra_address || row.netra_address.score == null) return <Typography sx={secondaryTextSx}>-</Typography>;
                const score = Math.round(Number(row.netra_address.score));
                const band = row.netra_address.band || '';
                const bgColor = NETRA_BAND_COLOR[band] || '#616161';
                return (
                    <Chip size="small" label={`${band} · ${score}`} sx={{ backgroundColor: bgColor, color: '#fff', fontWeight: 600, fontSize: 11 }} />
                )
            },
        },
        {
            field: 'status', headerAlign: "left", hideSortIcons: true, headerName: 'Current Status', flex: 1, minWidth: 130, renderCell: (params) => {
                const { row } = params;
                const orderStatus = row.orderStatus.replace(/_/g, ' ');
                const ofdCount = row.ndrData?.ofdCount || 0;
                return (
                    <Box sx={cellStackSx}>
                        <Chip size="small" label={orderStatus} sx={getStatusChipSx(row.orderStatus)} />
                        <Chip size="small" label={`OFD Attempts : ${ofdCount}`} sx={{ fontFamily: FONT, fontSize: 11, fontWeight: 600, height: 22, bgcolor: '#e3f2fd', color: '#1565c0', border: '1px solid #90caf940', '& .MuiChip-label': { px: 1 } }} />
                    </Box>
                )
            },
        },
        {
            field: 'shipment', headerAlign: "left", hideSortIcons: true, headerName: 'Delivery Address', flex: 1.5, minWidth: 200, renderCell: (params) => {
                const { row } = params;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={secondaryTextSx}>Name : {row.delivery_details.to_name}</Typography>
                        <Typography sx={secondaryTextSx}>
                            Phone : {shouldMaskData(report, row, piiAccessAllow) ? maskPhoneNumber(
                                row.delivery_details.to_phone_number
                            ) : (
                                row.delivery_details.to_phone_number
                            )}
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            {shouldMaskData(report, row, piiAccessAllow) ? maskAddress(
                                row.delivery_details.to_address,
                                row.delivery_details.to_city,
                                row.delivery_details.to_state,
                                row.delivery_details.to_pincode
                            ) : (
                                <>
                                    {row.delivery_details.to_address}
                                    {row.delivery_details.to_city}
                                    {row.delivery_details.to_state}
                                    {row.delivery_details.to_pincode}
                                </>
                            )}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'ndrReason', headerAlign: "left", hideSortIcons: true, headerName: 'NDR Reason', flex: 1.5, minWidth: 200, renderCell: (params) => {
                const { row } = params;
                const isDelhivery = row?.courierDetail?.parent?.toLowerCase() === 'delhivery';
                const lastAdditional = isDelhivery && Array.isArray(row?.order_history) && row.order_history.length > 0
                    ? row.order_history[row.order_history.length - 1].additional
                    : null;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={primaryTextSx}>
                            {(row.ndrData && row.ndrData.ndrCpStatusDescription) ? row.ndrData.ndrCpStatusDescription : "-NA-"}
                        </Typography>
                        <Typography sx={secondaryTextSx}>
                            {(row.ndrData && row.ndrData.ndrReportedDate) ? parseDateAndTime(row.ndrData.ndrReportedDate, true) : ""}
                        </Typography>
                        {lastAdditional?.nsl_code && (
                            <Typography sx={{ fontFamily: FONT, fontSize: 11, fontWeight: 600, color: ERROR, lineHeight: 1.4, mt: 0.3 }}>
                                NSL Code: {lastAdditional.nsl_code}
                            </Typography>
                        )}
                        {lastAdditional && (lastAdditional.latitude || lastAdditional.longitude) && (
                            <Typography sx={{ fontFamily: FONT, fontSize: 10, color: SUBTLE, lineHeight: 1.4 }}>
                                Lat: {lastAdditional.latitude || '-'}, Lng: {lastAdditional.longitude || '-'}
                            </Typography>
                        )}
                    </Box>
                )
            },
        },
        {
            field: 'interventions', headerAlign: "left", hideSortIcons: true, headerName: 'Interventions', flex: 1.2, minWidth: 220, renderCell: (params) => {
                const { row } = params;
                const recordings = callRecordingsMap[row.awb_number] || [];
                const manualCount = recordings.length;
                const manualConnected = recordings.filter(r => r.ndr_result && r.ndr_result !== 'Not Connected').length;
                const waMessages = whatsappMap[row.awb_number] || [];
                const waCount = waMessages.length;
                const totalTouches = manualCount + waCount;
                const manualColor = manualCount === 0 ? SUBTLE : manualConnected > 0 ? SUCCESS : ERROR;
                const waColor = waCount === 0 ? SUBTLE : SUCCESS;
                return (
                    <Box sx={cellStackSx}>
                        <Typography sx={{ fontFamily: FONT, fontSize: 11, fontWeight: 600, color: manualColor, lineHeight: 1.4 }}>
                            {`Manual call ×${manualCount} · ${manualConnected} connected`}
                        </Typography>
                        <Typography sx={{ fontFamily: FONT, fontSize: 11, fontWeight: 600, color: waColor, lineHeight: 1.4 }}>
                            {`WhatsApp ×${waCount}`}
                        </Typography>
                        <Typography sx={{ fontFamily: FONT, fontSize: 10, color: SUBTLE, bgcolor: '#f5f5f5', px: 0.8, py: 0.2, borderRadius: 0.5, lineHeight: 1.4 }}>
                            {`${totalTouches} ${totalTouches === 1 ? 'touch' : 'touches'}`}
                        </Typography>
                    </Box>
                )
            },
        },
        {
            field: 'action', headerAlign: "left", hideSortIcons: true, headerName: 'Action', flex: 1, minWidth: 160, renderCell: (params) => {
                const { row } = params;
                const blocked = isDelhiveryReattemptBlocked(row);
                return (
                    <Box sx={cellStackSx}>
                        <Button variant="contained" size="small" disabled={!!blocked} sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none', px: 1.5, py: 0.5 }} onClick={() => handleActionShow(row, "reattempt")}>Reattempt</Button>
                        {blocked && (
                            <Typography sx={{ fontFamily: FONT, fontSize: 10, color: ERROR, lineHeight: 1.3, maxWidth: 140 }}>
                                Reattempt not allowed by courier partner
                            </Typography>
                        )}
                        <Button variant="outlined" size="small" color="error" sx={{ fontFamily: FONT, fontSize: SIZE['2xs'], textTransform: 'none', px: 1.5, py: 0.5 }} onClick={() => handleClickRTO(row?.awb_number)}>RTO</Button>
                    </Box>
                )
            },
        },
    ];

    useEffect(() => {
        if (pendingData) {
            setPendingNDRData(pendingData);
            const awbs = (pendingData.data || []).map(r => r.awb_number).filter(Boolean);
            if (awbs.length > 0) {
                postGeneric(apiConstants.NDR_RECORDING_SEARCH, {
                    andfilter: [{ field: "awb_number", operator: "in", value: awbs }],
                }).then((res) => {
                    const map = {};
                    (res?.data?.data || []).forEach(rec => {
                        if (!map[rec.awb_number]) map[rec.awb_number] = [];
                        map[rec.awb_number].push(rec);
                    });
                    setCallRecordingsMap(map);
                }).catch(() => setCallRecordingsMap({}));
                postGeneric(apiConstants.DELIVERY_DB_SEARCH, {
                    collection: 'interaction_audit',
                    limit: 5000,
                    offset: 0,
                    skipCount: true,
                    excludes: 'payloadBody,associated_number,template_type,callback_body',
                    andfilter: [
                        { field: 'template_name', operator: 'in', value: ['ndr_workflow_initiate', 'ndr_workflow_initiate_without_address_flow'] },
                        { field: 'meta_data.merchantOid', operator: 'eq', value: merchantId },
                        { field: 'status', operator: 'eq', value: 'success' },
                        { field: 'meta_data.awbNumber', operator: 'in', value: awbs },
                    ],
                }).then((res) => {
                    const map = {};
                    (res?.data?.data || []).forEach(rec => {
                        const awb = rec?.meta_data?.awbNumber;
                        if (awb) {
                            if (!map[awb]) map[awb] = [];
                            map[awb].push(rec);
                        }
                    });
                    setWhatsappMap(map);
                }).catch(() => setWhatsappMap({}));
            } else {
                setCallRecordingsMap({});
                setWhatsappMap({});
            }
        }
    }, [pendingData]);


    const handleActionShow = (row, type) => {
        setCurrentNDRId(row);
        setCurrentNDRAction(type);
        setActionShow(true);
    };

    const handleActionClose = () => {
        setActionShow(false);
        setBulkOrderShow(false);
    };

    const handleClickRTO = (row) => {
        setRtoConfirm(true);
        setId(row);
    };

    const handleReattempt = (data) => {
        const payload = Object.assign(
            {},
            {
                waybill: `${currentNDRId.awb_number}`,
                action: "REATTEMPT",
            },
            data
        );
        const param = {
            ndr_waybills_data: [payload],
        };
        sendNDRAction(param);
    };

    const handleReturn = (id) => {
        const payload = Object.assign(
            {},
            {
                waybill: `${id}`,
                action: "INITIATE_RTO",
            }
        );
        const param = {
            ndr_waybills_data: [payload],
        };
        sendNDRAction(param);
    };

    const sendNDRAction = (param) => {
        setIsLoadingBtn(true)
        setIsExecuting(true);
        post(`${apiConstants.BASE_LOCAL}${apiConstants.NDR_ACTION}`, param)
            .then((response) => {
                setIsLoadingBtn(false)
                setIsExecuting(false);
                setCurrentNDRId({});
                setCurrentNDRAction();
                setActionShow(false);
                setReload(reload => reload + 1)
                if (response?.data?.result?.ndr_update_status[0]?.status === true && response.status === 200) {
                    enqueueSnackbar('Action performed successfully', { variant: 'success' });
                } else {
                    enqueueSnackbar(response?.data?.result?.ndr_update_status[0]?.cp_response, { variant: 'error' });
                }
            })
            .catch((err) => {
                setIsLoadingBtn(false)
                const message = err?.response?.data?.message || err.message;
                if (message === 'Target System Error') {
                    enqueueSnackbar("Please wait a few minutes before you try again", { variant: 'error' });
                }
                else {
                    enqueueSnackbar(err?.response?.data?.message || err.message, { variant: 'error' });
                }

                setIsExecuting(false);
            });
    };

    return (
        <>
            {(isLoading || isExecuting) && <Loader />}
            <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1.5 }}>
                <LoadingButton loading={downloading} onClick={handleDownload} variant="outlined" size="small" startIcon={<FileDownloadOutlinedIcon />} sx={secondaryBtnSx}>
                    Download
                </LoadingButton>
            </Box>
            <ProzoDataGrid columns={columns}
                // disableColumnFilter={true}rowsPerPageOptions
                autoHeight={true}
                rows={(pendingNdrData.data && pendingNdrData.data.length > 0) ? pendingNdrData.data : []}
                sizePerPage={sizePerPage}
                setSizePerPage={setSizePerPage}
                setPage={setPage}
                page={page}
                pagination={true}
                hideFooterPagination={false}
                filterMode={"server"}
                rowCount={Number.MAX_VALUE}
                getRowId={(row) => row.id} />
            <ConfirmDialog
                title=''
                open={rtoConfirm}
                setOpen={setRtoConfirm}
                onConfirm={() => handleReturn(id)}>
                Are you sure you want request for RTO?
            </ConfirmDialog>
            <NdrAction
                show={actionShow}
                handleClose={handleActionClose}
                currentNDRId={currentNDRId}
                currentNDRAction={currentNDRAction}
                handleReattemp={handleReattempt}
                setReload={setReload}
                isLoadingBtn={isLoadingBtn}
            />
            <BulkOrderAction
                show={bulkOrderShow}
                handleClose={handleActionClose}
                currentNDRId={currentNDRId}
                currentNDRAction={currentNDRAction}
                handleReattemp={handleReattempt}
                pendingNdrData={pendingNdrData}
                setReload={setReload}
            />
        </>
    );
};

export default PendingNdrData
